import Swal from "sweetalert2";

function stylePaymentDeclinedConfirm() {
  Swal.getContainer()?.style.setProperty("z-index", "100000");
  const popup = Swal.getPopup();
  const actions = popup?.querySelector(".swal2-actions");
  const btn = Swal.getConfirmButton();
  if (actions) {
    actions.style.width = "100%";
    actions.style.margin = "0.5rem 0 0";
    actions.style.padding = "0 1.25rem 1.35rem";
    actions.style.display = "flex";
    actions.style.justifyContent = "center";
  }
  if (btn) {
    btn.style.width = "100%";
    btn.style.maxWidth = "100%";
    btn.style.borderRadius = "9999px";
    btn.style.padding = "14px 24px";
    btn.style.fontWeight = "700";
    btn.style.fontSize = "1rem";
    btn.style.color = "#000";
    btn.style.border = "none";
    btn.style.background = "white";
  }
}

/** Themed SweetAlert2 dialog for a declined card / payment. */
export function showPaymentDeclinedAlert(error) {
    const errorMessage = error?.responseJSON?.payment_intent?.last_payment_error?.message ||
    error?.responseJSON?.message ||
    "Something went wrong on our end. Ticket(s) has not been purchased. Please try again or contact support.";
    const errorTitle = errorMessage.split(".")[0];
    const errorText = errorMessage.split(".")[1];

  return Swal.fire({
    title: errorTitle,
    text: errorText,
    confirmButtonText: "OK",
    background: "black",
    color: "white",
    buttonsStyling: false,
    didOpen: stylePaymentDeclinedConfirm,
  });
}
